<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >RPA流程执行</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item
                            title="虚拟机"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="是否启用"
                            field="isEnabled"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.isEnabled"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="启用"
                                    ></vxe-option>
                                    <vxe-option
                                        value="0"
                                        label="禁用"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="状态"
                            field="status"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="运行中"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入姓名或邮箱"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button
                                    @click="openCronModal"
                                    status="warning"
                                    title="为数字员工设置定时执行任务"
                                    >定时器设置</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        :loading="toolbar.loading"
                        class="mytable-scrollbar"
                        :data="tableData"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="id"
                            title="序号"
                            width="60"
                        ></vxe-column>
                        <vxe-column
                            field="status"
                            title="状态-操作"
                            width="120"
                            :title-help="{ message: '空闲中点击按钮运行流程' }"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    icon="fa fa-play"
                                    size="small"
                                    @click="startProcess(row)"
                                    :disabled="getDisable(row)"
                                    :status="getStatus(row)"
                                    round
                                    >{{ row.Status }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="StateName"
                            title="阶段状态"
                            width="100"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessName"
                            title="流程ID"
                            width="140"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ProcessNo"
                            title="流程名称"
                            width="250"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="NAME"
                            title="业务人员"
                            width="100"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="DevelopUser"
                            title="开发人员"
                            width="120"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="邮箱"
                            width="190"
                            resizable
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="Pc_No"
                            title="虚拟机"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="Abbr"
                            title="机器人简称"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="Levele"
                            title="优先级"
                            width="100"
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="创建时间"
                            width="140"
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="DevPlatform"
                            title="开发平台"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            title="操作"
                            width="80"
                            show-overflow
                            v-if="false"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-if="row.Display == '1'"
                                    status="warning"
                                    size="small"
                                    @click="stopRowEvent(row)"
                                    title="停用"
                                    >停用
                                </vxe-button>
                                <vxe-button
                                    v-else
                                    @click="startRowEvent(row)"
                                    size="small"
                                    status="warning"
                                    title="启用"
                                    >启用
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="首页隐藏"
                            width="100"
                            show-overflow
                            v-if="false"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    v-if="row.IsHidden == '是'"
                                    status="warning"
                                    size="small"
                                    @click="setProcessHidden(row)"
                                    title="首页机器人列表不显示"
                                    >是
                                </vxe-button>
                                <vxe-button
                                    v-else
                                    @click="setProcessHidden(row)"
                                    size="small"
                                    status="warning"
                                    title="首页机器人列表显示"
                                    >否
                                </vxe-button>
                            </template>
                        </vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
            <!-- 流程停用申请申请-->
            <vxe-modal
                v-model="formInputStop.isShow"
                :title="formInputStop.title"
                width="840"
                height="460"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <a-tabs v-model:activeKey="activeKey">
                        <a-tab-pane key="1" tab="新增申请">
                            <vxe-form
                                :data="formInputStop.formData"
                                :rules="formInputStop.formRules"
                                title-align="right"
                                ref="rFormStop"
                                title-width="60"
                            >
                                <vxe-form-item
                                    title="流程ID"
                                    field="processID"
                                    span="10"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputStop.formData.processID
                                            "
                                            placeholder="请输入流程ID"
                                            :disabled="
                                                formInputStop.allInputDisable
                                            "
                                            readonly
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item span="2">
                                    <template #default> </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="流程名称"
                                    field="processName"
                                    span="12"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputStop.formData
                                                    .processName
                                            "
                                            readonly
                                            placeholder="请输入流程名称"
                                            :disabled="
                                                formInputStop.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    title="业务人员"
                                    field="UserNameEmail"
                                    span="10"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputStop.formData
                                                    .UserNameEmail
                                            "
                                            placeholder="请输入业务人员"
                                            :disabled="
                                                formInputStop.allInputDisable
                                            "
                                            readonly
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item span="2">
                                    <template #default> </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="虚拟机"
                                    field="oldUserName"
                                    span="12"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputStop.formData
                                                    .oldUserName
                                            "
                                            readonly
                                            placeholder=""
                                            :disabled="
                                                formInputStop.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    title="申请原因"
                                    field="reqReason"
                                    span="24"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-textarea
                                            rows="4"
                                            v-model="
                                                formInputStop.formData.reqReason
                                            "
                                            placeholder="请输入停用原因"
                                            maxlength="1000"
                                            show-word-count
                                        ></vxe-textarea>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    align="center"
                                    span="24"
                                    v-if="!formInputStop.saveButDisable"
                                >
                                    <template #default>
                                        <vxe-button
                                            @click="closeStop()"
                                            icon="fa fa-close"
                                            status="danger"
                                            >退出
                                        </vxe-button>
                                        <vxe-button
                                            :loading="submitting"
                                            @click="submitStop"
                                            icon="fa fa-check"
                                            status="primary"
                                            >提交
                                        </vxe-button>
                                    </template>
                                </vxe-form-item>
                            </vxe-form>
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="申请历史">
                            <div style="overflow: hidden; height: 100%">
                                <vxe-table
                                    stripe
                                    class="mytable-scrollbar"
                                    :data="tableDataStop"
                                    :height="300"
                                    show-overflow
                                    :row-config="{
                                        height: 36,
                                        isHover: true,
                                        isCurrent: true,
                                    }"
                                    ref="xTableHis"
                                >
                                    <vxe-column
                                        type="seq"
                                        field="Id"
                                        title="序号"
                                        width="50"
                                    ></vxe-column>
                                    <vxe-column
                                        field="statusName"
                                        title="状态"
                                        width="100"
                                        show-overflow
                                        resizable
                                        sortable
                                    >
                                        <template #default="{ row }">
                                            <vxe-button
                                                v-bind:class="{
                                                    active:
                                                        row.statusName ===
                                                        '已审核',
                                                    error:
                                                        row.statusName ===
                                                        '已驳回',
                                                }"
                                                type="text"
                                                @click="showAuditList(row)"
                                                >{{ row.statusName }}
                                            </vxe-button>
                                        </template>
                                    </vxe-column>
                                    <vxe-column
                                        field="processName"
                                        title="流程名称"
                                        width="180"
                                        show-overflow
                                        resizable
                                        sortable
                                    ></vxe-column>
                                    <vxe-column
                                        field="processID"
                                        title="流程ID"
                                        width="120"
                                        sortable
                                    ></vxe-column>
                                    <vxe-column
                                        field="UserNameEmail"
                                        title="业务人员"
                                        width="100"
                                        show-overflow
                                        resizable
                                    ></vxe-column>
                                    <vxe-column
                                        field="creationTime"
                                        title="创建日期"
                                        width="120"
                                        sortable
                                        :formatter="formatTime"
                                    ></vxe-column>
                                    <vxe-column
                                        field="reqReason"
                                        title="申请原因"
                                        width="120"
                                        resizable
                                        show-overflow
                                    ></vxe-column>
                                </vxe-table>
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                </template>
            </vxe-modal>
            <!-- 流程使用申请-->
            <vxe-modal
                v-model="formInputStart.isShow"
                :title="formInputStart.title"
                width="840"
                height="460"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <a-tabs v-model:activeKey="activeKey">
                        <a-tab-pane key="1" tab="新增申请">
                            <vxe-form
                                :data="formInputStart.formData"
                                :rules="formInputStart.formRules"
                                title-align="right"
                                ref="rFormStart"
                                title-width="60"
                            >
                                <vxe-form-item
                                    title="流程ID"
                                    field="processID"
                                    span="10"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputStart.formData
                                                    .processID
                                            "
                                            placeholder="请输入流程ID"
                                            :disabled="
                                                formInputStart.allInputDisable
                                            "
                                            readonly
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item span="2">
                                    <template #default> </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="流程名称"
                                    field="processName"
                                    span="12"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputStart.formData
                                                    .processName
                                            "
                                            readonly
                                            placeholder="请输入流程名称"
                                            :disabled="
                                                formInputStart.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    title="业务人员"
                                    field="UserNameEmail"
                                    span="10"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputStart.formData
                                                    .UserNameEmail
                                            "
                                            placeholder="请输入业务人员"
                                            :disabled="
                                                formInputStart.allInputDisable
                                            "
                                            readonly
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>
                                <vxe-form-item span="2">
                                    <template #default> </template>
                                </vxe-form-item>
                                <vxe-form-item
                                    title="虚拟机"
                                    field="oldUserName"
                                    span="12"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-input
                                            v-model="
                                                formInputStart.formData
                                                    .oldUserName
                                            "
                                            readonly
                                            placeholder=""
                                            :disabled="
                                                formInputStart.allInputDisable
                                            "
                                        ></vxe-input>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    title="申请原因"
                                    field="reqReason"
                                    span="24"
                                    title-width="100px"
                                >
                                    <template #default>
                                        <vxe-textarea
                                            rows="4"
                                            v-model="
                                                formInputStart.formData
                                                    .reqReason
                                            "
                                            placeholder="请输入启用原因"
                                            maxlength="1000"
                                            show-word-count
                                        ></vxe-textarea>
                                    </template>
                                </vxe-form-item>

                                <vxe-form-item
                                    align="center"
                                    span="24"
                                    v-if="!formInputStart.saveButDisable"
                                >
                                    <template #default>
                                        <vxe-button
                                            @click="closeStart()"
                                            icon="fa fa-close"
                                            status="danger"
                                            >退出
                                        </vxe-button>
                                        <vxe-button
                                            :loading="submitting"
                                            @click="submitStart"
                                            icon="fa fa-check"
                                            status="primary"
                                            >提交
                                        </vxe-button>
                                    </template>
                                </vxe-form-item>
                            </vxe-form>
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="申请历史">
                            <div style="overflow: hidden; height: 100%">
                                <vxe-table
                                    stripe
                                    class="mytable-scrollbar"
                                    :data="tableDataStart"
                                    :height="300"
                                    show-overflow
                                    :row-config="{
                                        height: 36,
                                        isHover: true,
                                        isCurrent: true,
                                    }"
                                    ref="xTableHis"
                                >
                                    <vxe-column
                                        type="seq"
                                        field="Id"
                                        title="序号"
                                        width="50"
                                    ></vxe-column>
                                    <vxe-column
                                        field="statusName"
                                        title="状态"
                                        width="100"
                                        show-overflow
                                        resizable
                                        sortable
                                    >
                                        <template #default="{ row }">
                                            <vxe-button
                                                v-bind:class="{
                                                    active:
                                                        row.statusName ===
                                                        '已审核',
                                                    error:
                                                        row.statusName ===
                                                        '已驳回',
                                                }"
                                                type="text"
                                                @click="showAuditList(row)"
                                                >{{ row.statusName }}
                                            </vxe-button>
                                        </template>
                                    </vxe-column>
                                    <vxe-column
                                        field="processName"
                                        title="流程名称"
                                        width="180"
                                        show-overflow
                                        resizable
                                        sortable
                                    ></vxe-column>
                                    <vxe-column
                                        field="processID"
                                        title="流程ID"
                                        width="120"
                                        sortable
                                    ></vxe-column>
                                    <vxe-column
                                        field="UserNameEmail"
                                        title="业务人员"
                                        width="100"
                                        show-overflow
                                        resizable
                                    ></vxe-column>
                                    <vxe-column
                                        field="creationTime"
                                        title="创建日期"
                                        width="120"
                                        sortable
                                        :formatter="formatTime"
                                    ></vxe-column>
                                    <vxe-column
                                        field="reqReason"
                                        title="申请原因"
                                        width="120"
                                        resizable
                                        show-overflow
                                    ></vxe-column>
                                </vxe-table>
                            </div>
                        </a-tab-pane>
                    </a-tabs>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive, ref, toRef } from "vue";
import { VXETable, VxeTableInstance, VxeTablePropTypes } from "vxe-table";
import XEUtils from "xe-utils";
import MyAuditLine from "../myPlug/MyAuditLine";

export default {
    name: "ProcessTakeList",
    components: { MyAuditLine },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            formData: {
                selectMac: "",
                status: "",
                searchKey: "",
                isEnabled: "1",
            },
        });
        const formInputStop = reactive({
            title: "流程停用申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: true,
            formData: {
                Id: "",
                pubId: "",
                reqType: "2", //停用
                status: "0",
                processID: "",
                processName: "",
                UserName: "",
                UserNameEmail: "",
                oldUserName: "",
                reqReason: "",
                creator: "",
            },
            formRules: {
                reqReason: [{ required: true, message: "停用原因不能为空" }],
            },
        });
        const formInputStart = reactive({
            title: "流程启用申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: true,
            formData: {
                Id: "",
                pubId: "",
                reqType: "3", //使用用
                status: "0",
                processID: "",
                processName: "",
                UserName: "",
                UserNameEmail: "",
                oldUserName: "",
                reqReason: "",
                creator: "",
            },
            formRules: {
                reqReason: [{ required: true, message: "启用原因不能为空" }],
            },
        });
        const activeKey = ref("1");
        return {
            tableData: null,
            tableDataStop: null,
            tableDataStart: null,
            tablePager,
            toolbar,
            pageHeight,
            timer: null,
            tableHeight: 0,
            formInputStop,
            formInputStart,
            activeKey,
            submitting: false,
            isShowAuditList: false,
            dtAudit: null,
        };
    },
    methods: {
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        formatTime({ cellValue, row, column }) {
            return XEUtils.toDateString(cellValue, "yyyy-MM-dd");
        },
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        openCronModal() {
            this.$router.push({ name: "robotCronList" });
        },
        //查询
        findData() {
            this.toolbar.loading = true;
            let selPc = "",
                selEnable = "",
                selStatus = "",
                selKey = "";
            selPc = this.toolbar.formData.selectMac;
            selEnable = this.toolbar.formData.isEnabled;
            selStatus = this.toolbar.formData.status;
            selKey = this.toolbar.formData.searchKey;
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: ["0", selPc, selEnable, selStatus, selKey],
            };
            this.$api.jobManageAPI
                .getProcessTakeList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.toolbar.loading = false;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                    this.toolbar.loading = false;
                })
                .finally(() => {
                    this.toolbar.loading = false;
                });
        },
        //启动一个流程
        async startProcess(row) {
            const type = await VXETable.modal.confirm("您确定要运行该流程吗?");
            if (type === "confirm") {
                const params = {
                    uid: this.$store.state.userID,
                    email: this.$store.state.email,
                    actionType: "1",
                    actionKey: [row.id, this.$store.state.userName],
                };
                this.$api.jobManageAPI
                    .startProcess(Qs.stringify(params))
                    .then((res) => {
                        if (res.data.Success == false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        // console.log(res.data.Data);
                        this.findData();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //申请停用
        async stopRowEvent(row) {
            this.activeKey = ref("1");
            this.formInputStop.formData.Id = this.$utils.guid();
            this.formInputStop.formData.pubId = row.id;
            this.formInputStop.formData.processID = row.ProcessName;
            this.formInputStop.formData.processName = row.ProcessNo;
            this.formInputStop.formData.UserNameEmail =
                row.NAME + "(" + row.UserName + ")";
            this.formInputStop.formData.UserName = row.UserName;
            this.formInputStop.formData.oldUserName = row.Pc_No;
            this.formInputStop.formData.reqReason = "";
            this.formInputStop.formData.creator = this.$store.state.Id;

            this.findAddManHis(row.id, 1);
            this.formInputStop.isShow = true;
        },
        //提交停用申请
        async submitStop() {
            const $rForm = this.$refs.rFormStop;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitting = false;
                return;
            }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");

            if (type === "confirm") {
                const data = this.formInputStop.formData;

                this.submitting = true;
                this.$api.publishManageAPI
                    .submitPublishStop(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0", "1"); //写审核日志
                        this.formInputStop.isShow = false;
                        this.submitting = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        //设置是否首页显示
        async setProcessHidden(row) {
            const isHidden = row.IsHidden;
            const msg = isHidden === "是" ? "显示" : "隐藏";
            const type = await VXETable.modal.confirm(
                "您确定要在首页" + msg + "流程吗?"
            );

            if (type === "confirm") {
                const data = this.formInputStop.formData;

                this.submitting = true;
                this.$api.publishManageAPI
                    .submitPublishStop(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0", "1"); //写审核日志
                        this.formInputStop.isShow = false;
                        this.submitting = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        //申请使用
        async startRowEvent(row) {
            this.activeKey = ref("1");
            this.formInputStart.formData.Id = this.$utils.guid();
            this.formInputStart.formData.pubId = row.id;
            this.formInputStart.formData.processID = row.ProcessName;
            this.formInputStart.formData.processName = row.ProcessNo;
            this.formInputStart.formData.UserNameEmail =
                row.NAME + "(" + row.UserName + ")";
            this.formInputStart.formData.UserName = row.UserName;
            this.formInputStart.formData.oldUserName = row.Pc_No;
            this.formInputStart.formData.reqReason = "";
            this.formInputStart.formData.creator = this.$store.state.Id;

            this.findAddManHis(row.id, 2);
            this.formInputStart.isShow = true;
        },
        //提交使用申请
        async submitStart() {
            const $rForm = this.$refs.rFormStart;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitting = false;
                return;
            }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");

            if (type === "confirm") {
                const data = this.formInputStart.formData;

                this.submitting = true;
                this.$api.publishManageAPI
                    .submitPublishStart(Qs.stringify(data))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0", "2"); //写审核日志
                        this.formInputStart.isShow = false;
                        this.submitting = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        addAuditRecord(status, type) {
            let auditBuId = "";
            let auditOpinion = "";
            switch (type) {
                case "1":
                    auditBuId = this.formInputStop.formData.Id;
                    auditOpinion = "流程停用发起";
                    break;
                case "2":
                    auditBuId = this.formInputStart.formData.Id;
                    auditOpinion = "流程启用发起";
                    break;
            }
            //写审核日志
            const params = {
                auditBuId: auditBuId,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: auditOpinion,
                auditNode: "审核发起",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showAsset() {
            this.$router.push({ name: "assetList" });
        },
        getStatus(row) {
            if (row.Status === "空闲中") {
                return "success";
            }
        },
        closeStop() {
            this.formInputStop.isShow = false;
        },
        closeStart() {
            this.formInputStart.isShow = false;
        },
        // type 1 停用 2 使用
        findAddManHis(pubId, type) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 100,
                searchKey: [pubId, "", type == "1" ? "2" : "3"],
            };
            this.$api.publishManageAPI
                .getProcessAddManList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    if (type == 1) {
                        this.tableDataStop = res.data.Data.dataTable;
                    } else {
                        this.tableDataStart = res.data.Data.dataTable;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getDisable(row) {
            return row.Status !== "空闲中";
        },
        handlePageChange() {
            this.findData();
        },
        bindPC() {
            this.$api.systemManageAPI
                .getMachineList()
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.PcName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.selectMac = "";
            this.toolbar.formData.isEnabled = "1";
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        setTimer() {
            this.timer = setInterval(() => {
                window.setTimeout(this.findData, 0);
            }, 1000 * 15);
        },
        clearTimer() {
            window.clearInterval(this.timer);
            this.timer = null;
        },
    },
    mounted() {
        this.bindPC();
        this.findData();
        this.setTimer();
        window.addEventListener("keydown", this.keydown);
    },
    beforeUnmount() {
        window.removeEventListener("keydown", this.keydown, false);
        this.clearTimer();
    },
};
</script>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>
